import { withRouter } from "react-router-dom";
import * as _ from "lodash";
import MainContent from "../../boxes/MainContent";
import PageHeader from "../../boxes/PageHeader";
import PageBody from "../../boxes/PageBody";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import LoadingScreen from "../../LoadingScreen";
import CareHistoryTable from "../CareHistoryTable";



function Pagination({ offset, limit, total, onPrev, onNext }) {
  const currentPage = Math.floor(offset / limit) + 1;
  const totalPages = Math.ceil(total / limit);

  const buttonStyle = {
    padding: "8px 20px",
    borderRadius: "4px",
    border: "1px solid #094063",
    background: "#fff",
    color: "#094063",
    fontWeight: 600,
    fontSize: "1.2rem",
    cursor: "pointer",
    transition: "background 0.2s, color 0.2s",
    outline: "none",
    minWidth: "80px",
    margin: "0 4px",
    opacity: 1,
  };

  const disabledStyle = {
    ...buttonStyle,
    background: "#F2F2F2",
    color: "#BDBDBD",
    border: "1px solid #F2F2F2",
    cursor: "not-allowed",
    opacity: 0.7,
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "16px",
        marginTop: "24px",
        alignItems: "center",
      }}
    >
      <button
        style={currentPage === 1 ? disabledStyle : buttonStyle}
        onClick={onPrev}
        disabled={currentPage === 1}
      >
        &#8592; Prev
      </button>
      <span
        style={{
          fontWeight: 500,
          fontSize: "1.2rem",
          color: "#212121",
          minWidth: "100px",
          textAlign: "center",
        }}
      >
        Page {currentPage} of {totalPages}
      </span>
      <button
        style={currentPage === totalPages ? disabledStyle : buttonStyle}
        onClick={onNext}
        disabled={currentPage === totalPages}
      >
        Next &#8594;
      </button>
    </div>
  );
}

function CareHistoryContainer(props) {
  const { user } = props;

  const { t } = useTranslation("careBalance");

  const [offset, setOffset] = useState(1);
  const [limit] = useState(20);
  const [count, setCount] = useState(0);

  if (_.isEmpty(user?.hmoId)) {
    return <LoadingScreen />;
  }

  return (
    <>
      <MainContent>
        <PageHeader title={t("careHistoryPageTitle")}/>

        <PageBody>
          <CareHistoryTable
            setCount={setCount}
            limit={limit}
            offset={offset}
            hmoId={user.hmoId}
            showFilter={true}
          />

          <Pagination
            offset={offset}
            limit={limit}
            total={count}
            onPrev={() => setOffset(Math.max(0, offset - limit))}
            onNext={() => setOffset(offset + limit)}
          />
        </PageBody>
      </MainContent>
    </>
  );
}

export default withRouter(CareHistoryContainer);
